import { useRef, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { useWeb3Connection } from 'dibs-crypto-utils/exports/useWeb3Connection';
import { supportedChains, getLongChainName } from 'dibs-crypto-utils/exports/supportedChains';

export const useChainNames = (): {
    requiredNetworks: string;
    connectedNetwork: string | ReactNode;
    isLocalHost: boolean;
} => {
    const { chainId } = useWeb3Connection();
    const requiredChainIdRef = useRef<Array<number>>(supportedChains());

    const requiredNetworks = requiredChainIdRef.current
        .map(id => getLongChainName(id))
        .filter(chain => !!chain)
        .join(' or ');
    const connectedNetwork = chainId ? (
        getLongChainName(chainId)
    ) : (
        <FormattedMessage
            id="nft.pdp.unsupportedNetwork.unsupported"
            defaultMessage="an unsupported"
        />
    );
    return {
        requiredNetworks,
        connectedNetwork,
        isLocalHost: requiredChainIdRef.current.includes(1337),
    };
};
